import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'

import router from './env/router'
import './env/coms'
import store from './env/vuex'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
